import { render, staticRenderFns } from "./post-card-wide.vue?vue&type=template&id=08dc4c95&"
import script from "./post-card-wide.vue?vue&type=script&lang=js&"
export * from "./post-card-wide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports